const translationMapping = {
  "en-US": {
    messages: "en",
    intlLocale: "en",
    momentLocale: "en"
  },
  "en-GB": {
    messages: "en",
    intlLocale: "en",
    momentLocale: "en-gb"
  }
};

export { translationMapping };



// WEBPACK FOOTER //
// ./src/translations.js